import { fromJS } from 'immutable';

import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as massUpdateActions from '../actions/massUpdate';

import { fetchingState } from '@constants';

const initialState = {
  massUpdate: { data: {}, state: null },
  massUpdateConfig: { data: {}, state: null },
  massUpdateGroupList: { data: [], state: null },
  massUpdateGroup: { data: {}, state: null },
  massUpdateAction: { data: {}, state: null },
  massUpdateGroupSingle: { data: {}, state: null },
  dropdowns: { data: {}, state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case massUpdateActions.SET_MANUAL_DROPDOWNS: {
      return state
        .setIn(['dropdowns', 'data'], fromJS(action.data))
        .setIn(['dropdowns', 'state'], fetchingState.LOADED);
    }
    case massUpdateActions.RESET_UPDATE_DATA: {
      return state
        .setIn(['massUpdateGroupSingle', 'data'], fromJS({}))
        .setIn(['massUpdateGroup', 'data'], fromJS({}))
        .setIn(['massUpdateGroupSingle', 'state'], null)
        .setIn(['massUpdateGroup', 'state'], null);
    }
    case massUpdateActions.FETCH_MASS_UPDATE_GROUP_SINGLE[START]:
      return state.setIn(
        ['massUpdateGroupSingle', 'state'],
        fetchingState.FETCHING,
      );
    case massUpdateActions.DELETE_MASS_UPDATE_GROUP[SUCCESS]:
      let searchResults = state.getIn(['massUpdateGroupList', 'data']).toJS();
      for (let x = 0; x < searchResults.length; x++) {
        if (searchResults[x].massUpdateGroupID === action.massUpdateGroupID) {
          searchResults.splice(x, 1);
          break;
        }
      }
      return state
        .setIn(['massUpdateGroupSingle', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdateGroupSingle', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['massUpdateGroupList', 'data'], fromJS(searchResults));
    case massUpdateActions.FETCH_MASS_UPDATE_GROUP_SINGLE[SUCCESS]:
      searchResults = state.getIn(['massUpdateGroupList', 'data']).toJS();
      if (
        action.data.results &&
        action.data.results.massUpdateGroupData &&
        action.data.results.massUpdateGroupData[0]
      ) {
        for (let x = 0; x < searchResults.length; x++) {
          if (
            searchResults[x].massUpdateGroupID ===
            action.data.results.massUpdateGroupData[0].massUpdateGroupID
          ) {
            searchResults[x].runStatus =
              action.data.results.massUpdateGroupData[0].runStatus;
          }
        }
      }
      return state
        .setIn(['massUpdateGroupSingle', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdateGroupSingle', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['massUpdateGroupList', 'data'], fromJS(searchResults));
    case massUpdateActions.FETCH_MASS_UPDATE_GROUP_SINGLE[ERROR]:
      return state.setIn(
        ['massUpdateGroupSingle', 'state'],
        fetchingState.ERROR,
      );

    case massUpdateActions.FETCH_ALL_MASS_UPDATE_GROUPS[START]:
      return state.setIn(
        ['massUpdateGroupList', 'state'],
        fetchingState.FETCHING,
      );
    case massUpdateActions.FETCH_ALL_MASS_UPDATE_GROUPS[SUCCESS]:
      return state
        .setIn(['massUpdateGroupList', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdateGroupList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    case massUpdateActions.FETCH_ALL_MASS_UPDATE_GROUPS[ERROR]:
      return state.setIn(['massUpdateGroupList', 'state'], fetchingState.ERROR);

    case massUpdateActions.FETCH_DROPDOWNS[START]:
      return state.setIn(['dropdowns', 'state'], fetchingState.FETCHING);
    case massUpdateActions.FETCH_DROPDOWNS[SUCCESS]:
      return state
        .setIn(['dropdowns', 'state'], fetchingState.LOADED)
        .setIn(
          ['dropdowns', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    case massUpdateActions.FETCH_DROPDOWNS[ERROR]:
      return state.setIn(['dropdowns', 'state'], fetchingState.ERROR);

    case massUpdateActions.FETCH_MASS_UPDATE_CONFIG[START]: {
      return state.setIn(['massUpdateConfig', 'state'], fetchingState.FETCHING);
    }
    case massUpdateActions.FETCH_MASS_UPDATE_CONFIG[SUCCESS]: {
      return state
        .setIn(['massUpdateConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdateConfig', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case massUpdateActions.FETCH_MASS_UPDATE_CONFIG[ERROR]: {
      return state.setIn(['massUpdateConfig', 'state'], fetchingState.ERROR);
    }
    case massUpdateActions.PERFORM_MASS_UPDATE[START]: {
      return state.setIn(['massUpdate', 'state'], fetchingState.FETCHING);
    }
    case massUpdateActions.PERFORM_MASS_UPDATE[SUCCESS]: {
      return state
        .setIn(['massUpdate', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdate', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case massUpdateActions.PERFORM_MASS_UPDATE[ERROR]: {
      return state.setIn(['massUpdate', 'state'], fetchingState.ERROR);
    }
    case massUpdateActions.UNDO_MASS_UPDATE[START]: {
      return state.setIn(['massUpdate', 'state'], fetchingState.FETCHING);
    }
    case massUpdateActions.UNDO_MASS_UPDATE[SUCCESS]: {
      return state
        .setIn(['massUpdate', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdate', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case massUpdateActions.UNDO_MASS_UPDATE[ERROR]: {
      return state.setIn(['massUpdate', 'state'], fetchingState.ERROR);
    }
    case massUpdateActions.INSERT_MASS_UPDATE_ACTION[START]: {
      return state.setIn(['massUpdateAction', 'state'], fetchingState.FETCHING);
    }
    case massUpdateActions.INSERT_MASS_UPDATE_ACTION[SUCCESS]: {
      return state
        .setIn(['massUpdateAction', 'state'], fetchingState.LOADED)
        .setIn(
          ['massUpdateAction', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case massUpdateActions.INSERT_MASS_UPDATE_ACTION[ERROR]: {
      return state.setIn(['massUpdateAction', 'state'], fetchingState.ERROR);
    }
    case massUpdateActions.INSERT_MASS_UPDATE_GROUP[START]: {
      return state.setIn(['massUpdateGroup', 'state'], fetchingState.FETCHING);
    }
    case massUpdateActions.INSERT_MASS_UPDATE_GROUP[SUCCESS]: {
      let searchResults = state.getIn(['massUpdateGroupList', 'data']).toJS();
      if (action.data.results[0]) {
        searchResults.push(action.data.results[0]);
      }
      return state
        .setIn(['massUpdateGroup', 'state'], fetchingState.LOADED)
        .setIn(['massUpdateGroupList', 'data'], fromJS(searchResults))
        .setIn(
          ['massUpdateGroup', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case massUpdateActions.INSERT_MASS_UPDATE_GROUP[ERROR]: {
      return state.setIn(['massUpdateGroup', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
